// extracted by mini-css-extract-plugin
module.exports = {"button8":"button8-module--button8--3aRzx","secondary":"button8-module--secondary--1d1hS","primary":"button8-module--primary--7x3tp"};